import React from 'react';
import { connect } from 'react-redux';
import theme from './OrderExpand.module.scss';
import { IState } from '@/state/IState';
import ProjectOrderDetails from '@/seller/components/project/ProjectOrderDetails';
import { BatchedChanges, Order } from '@/types';
import { getOrder } from '@/services/orders';
import { classnames } from '@/utils/html';

const mapDispatchToProps = () => ({});
const mapStateToProps = (state: IState) => ({
    profileId: state.global.activeProfile!.id,
});

type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> & {
        order: Order;
        onChange(changes: BatchedChanges<Order>): void;
        onLoad?: () => void;
    };

const OrderExpand: React.FC<Props> = ({ order, onChange, onLoad }) => {
    const onOrderChange = async () => {
        const updatedOrder = await getOrder(order.id);
        onChange(BatchedChanges.single(updatedOrder.id, updatedOrder));
    };

    return (
        <div className={classnames(theme.container)}>
            <ProjectOrderDetails onOrderChange={onOrderChange} order={order} onLoad={onLoad} />
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderExpand);
